import React, { useState } from 'react';
import './Pages/PagesCss/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
      
      // Reset status after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);
    }, 2000);
  };

  const contactInfo = [
    {
      icon: 'fa-solid fa-envelope',
      title: 'Email Us',
      details: 'support@noobtobull.com',
      description: 'Send us an email anytime'
    },
    {
      icon: 'fa-solid fa-location-dot',
      title: 'Visit Us',
      details: '2568 Madison Ave, League City, TX 77573',
      description: 'Come say hello at our office'
    }
  ];

  const faqs = [
    {
      question: "How accurate are your calculators?",
      answer: "Our calculators use industry-standard formulas and are regularly updated to ensure maximum accuracy for your financial planning."
    },
    {
      question: "Are my financial data secure?",
      answer: "Yes, we don't store any sensitive financial data. All calculations are performed locally in your browser for maximum security."
    },
    {
      question: "Can I suggest new calculator features?",
      answer: "Absolutely! We welcome feature suggestions and are constantly working to improve our tools based on user feedback."
    },
    {
      question: "Do you offer enterprise solutions?",
      answer: "Yes, we provide custom calculator solutions for businesses. Contact us to discuss your specific requirements."
    }
  ];

  return (
    <div className="contact">
      {/* Header Section */}
      <section className="contact-header">
        <div className="container">
          <div className="header-content">
            <h1>Get in Touch</h1>
            <p>Have questions about our financial calculators? We're here to help you make better financial decisions.</p>
          </div>
        </div>
      </section>

      {/* Main Contact Section */}
      <section className="contact-main">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-section">
              <div className="form-header">
                <h2>Send us a Message</h2>
                <p>Fill out the form below and we'll get back to you within 24 hours.</p>
              </div>

              {submitStatus === 'success' && (
                <div className="success-message">
                  <span className="success-icon">✓</span>
                  <div>
                    <h4>Message Sent Successfully!</h4>
                    <p>Thank you for contacting us. We'll get back to you soon.</p>
                  </div>
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter your full name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Enter your email address"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="What is this regarding?"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Tell us how we can help you..."
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className={`submit-btn ${isSubmitting ? 'submitting' : ''}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner"></span>
                      Sending...
                    </>
                  ) : (
                    'Send Message'
                  )}
                </button>
              </form>
            </div>

            {/* Contact Information */}
            <div className="contact-info-section">
              <div className="info-header">
                <h2>Contact Information</h2>
                <p>Choose your preferred method to reach out to us.</p>
              </div>

              <div className="contact-methods">
                {contactInfo.map((method, index) => (
                  <div key={index} className="contact-method">
                    <div className="method-icon"><i class={method.icon}></i></div>
                    <div className="method-details">
                      <h4>{method.title}</h4>
                      <p className="method-main">{method.details}</p>
                      <p className="method-desc">{method.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* FAQ Section */}
              <div className="faq-section">
                <h3>Frequently Asked Questions</h3>
                <div className="faq-list">
                  {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                      <h4>{faq.question}</h4>
                      <p>{faq.answer}</p>
                    </div>
                  ))}
                </div>
              </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Calculating?</h2>
            <p>Explore our comprehensive suite of financial calculators and take control of your finances today.</p>
            <div className="cta-buttons">
              <a href="/StockProfitCalculator" className="btn btn-primary">Browse Calculators</a>
              <a href="/About" className="btn btn-secondary">Learn More</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;